import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxImgCompositeComponent } from './rx-img-composite.component';
import { RxColModule } from '@nrwl/rx-col';

@NgModule({
  imports: [CommonModule, RxColModule, RxImgCompositeComponent],
  exports: [RxImgCompositeComponent],
})
export class RxImgCompositeModule {}
